import React from "react";


const PublicationApprovalField = ({publication, isApproved, approvePublication}) => {
    const setCheckboxDisabledValue = () => {
        if (publication && publication.citation.length && publication.therapeutic_areas.length && !isNaN(publication.year)) {
            return false
        } else {
            return true
        }
    }

    return (
        <div className="publication-approval-field">
            <label style={{cursor: "pointer"}}>
                Approved:
                <input
                    type="checkbox"
                    disabled={setCheckboxDisabledValue()}
                    checked={isApproved}
                    onChange={approvePublication}
                    style={{marginLeft: "10px", cursor: "pointer"}}
                />
            </label>
            <p style={{fontSize: "0.9em"}}><em>(<strong>Citation</strong>, <strong>Year</strong>, and <strong>Therapeutic Area(s)</strong> must be filled to approve publication.)</em></p>
        </div>
    )
}

export default PublicationApprovalField


// WEBPACK FOOTER //
// ./src/routes/publications/components/PublicationApprovalField.js